import { supabase } from '@/integrations/supabase/client';

export interface OpenRouterMessage {
  role: 'user' | 'assistant' | 'system';
  content: string | Array<{
    type: 'text' | 'image_url';
    text?: string;
    image_url?: { url: string };
  }>;
}

export interface NovaAttachment {
  name?: string;
  mime?: string;
  base64: string;
}

export const analyzeWithNova = async ({
  messages,
  imageUrls = [],
  imageUrlsFallback,
  files
}: {
  messages: OpenRouterMessage[];
  imageUrls?: string[];
  imageUrlsFallback?: string[];
  files?: NovaAttachment[];
}) => {
  try {
    const { data, error } = await supabase.functions.invoke('openrouter-nova', {
      body: {
        messages,
        image_urls: imageUrls,
        image_urls_fallback: Array.isArray(imageUrlsFallback) ? imageUrlsFallback.filter(Boolean) : undefined,
        files
      }
    });

    if (error) {
      console.error('Error invoking OpenRouter Nova function:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error in analyzeWithNova:', error);
    throw error;
  }
};

// Helper function to prepare messages for Nova
// This will handle both text and image content
export const prepareNovaMessages = ({
  text,
  imageUrls = []
}: {
  text: string;
  imageUrls?: string[];
}): OpenRouterMessage[] => {
  const messages: OpenRouterMessage[] = [];

  // Add system message if needed
  messages.push({
    role: 'system',
    content: 'You are a helpful AI assistant that can analyze images and text.'
  });

  // Add user message with text and optional images
  const userMessage: OpenRouterMessage = {
    role: 'user',
    content: [
      { type: 'text', text }
    ]
  };

  // Add images if any
  if (imageUrls.length > 0) {
    imageUrls.forEach(url => {
      (userMessage.content as any[]).push({
        type: 'image_url',
        image_url: { url }
      });
    });
  }

  messages.push(userMessage);
  return messages;
};
